module.exports = __webpack_public_path__ + "static/img/smuggler1.71fcb07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/smuggler1.png
// module id = nRqE
// module chunks = 0